/** ==========================================================================
 *  Dependencies
 *  =========================================================================*/

/**
 * External
 */
require('hammerjs');
require('objectFitPolyfill');
require('lazyload');
// const LazyLoad = require("vanilla-lazyload");

/**
 * Global / Shared with KMS
 */
require('./../global/polyfills/eventPolyFill');
require('./../global/polyfills/isInteger');
require('./../global/polyfills/promise');
require('./../global/polyfills/symbol-es6.min');


/** ==========================================================================
 *  Global functionalities
 *  =========================================================================*/

require('./global/helpers'); // Should be first
require('./global/browserHandler');
// require('./global/pagetransitionHandler');
// require('./global/resizeHandler');
require('./global/scrollHandler');


/** ==========================================================================
 *  Component functionalities
 *  =========================================================================*/

require('./components/chocolateFactory');
require('./components/cookieHandler');
require('./components/heroSliderHandler');
require('./components/imageRackHandler');
// require('./components/InputHandler');
require('./components/mapsHandler');
require('./components/overlayMenuHandler');
require('./components/projectorHandler');
require('./components/scrollToHandler');
// require('./components/searchHandler');
require('./components/shareButtonsHandler');
require('./components/youtubeHandler');

/** ==========================================================================
 *  Shop Component functionalities
 *  =========================================================================*/

// require('./../shop/components/shoppingcartHandler');

// const lazyLoadInstance = new LazyLoad({
//     elements_selector: '.js-lazy'
//     // Your custom settings go here
// });

let images = document.querySelectorAll('.js-lazy');
lazyload(images);


// window.addEventListener("load", () => {
//     if ("serviceWorker" in navigator) {
//         navigator.serviceWorker.register("/sw.js");
//     }
// });